
import React, { useEffect ,useState} from 'react';
import HelmetMeta from '../components/layouts/HelmetMeta';
import { useTranslation } from "react-i18next";
import { legalHTML } from '../utils/constants';
import { NavLink } from 'react-router-dom';
import Footer from '../components/layouts/Footer';

const Privacy = () => {

  const [t, i18n] = useTranslation("global");
  const [contentHtml,setContentHtml] = useState({privacyHtml:''});

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (legalHTML && legalHTML[i18n.language]) {
      setContentHtml(legalHTML[i18n.language]);
    }
  }, [i18n.language]);

  return (
    <section className='width-100 flex white-bg'>

      <HelmetMeta page="privacy"/>
            
      <div className='constrain-width padding-sides'>
          <div className='annexe' dangerouslySetInnerHTML={{ __html: contentHtml.privacyHtml }} />
      </div>
      <div className='annexe-menu'>
          <NavLink to='/legal' className='text-dark'><p>{t("footer.legal")}</p></NavLink>
          <p> - </p>
          <NavLink to='/support' className='text-dark'><p>{t("footer.faq")}</p></NavLink>
          <p> - </p>
          <NavLink to='/contact' className='text-dark'><p>{t("hero.contact.title")}</p></NavLink>
        </div>
      <Footer />
    </section>
  );
}

export default Privacy;